function cpfMask(value: string) {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
}

function cnpjMask(value: string) {
  return value
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
    .replace(
      /^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2}).*/,
      "$1.$2.$3/$4-$5"
    );
}

function cepMask(value: string) {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{5})(\d{3})/, "$1-$2")
    .replace(/(-\d{3})\d+?$/, "$1");
}

function phoneMask(value: string) {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{5})(\d{3})/, "$1-$2")
    .replace(/(-\d{3})\d+?$/, "$1");
}

function yearMask(value: string) {
  return value.replace(/\D/g, "").replace(/^(\d{4})\d+$/, "$1");
}

function monthDayMask(value: string) {
  return value.replace(/\D/g, "").replace(/^(\d{2})\d+$/, "$1");
}

function dateBRMask(value: string) {
  return value
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/, "$1/$2")
    .replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3")
    .replace(/^(\d{2})\/(\d{2})\/(\d{4}).*/, "$1/$2/$3");
}

export function applyMask(type: string, value: string) {
  switch (type) {
    case "cpf":
      return cpfMask(value);
    case "cnpj":
      return cnpjMask(value);
    case "cep":
      return cepMask(value);
    case "telefone":
      return phoneMask(value);
    case "ano":
      return yearMask(value);
    case "mes":
    case "dia":
      return monthDayMask(value);
    case "data":
      return dateBRMask(value);
    default:
      return value;
  }
}
